import { render } from "./RightButtons.vue?vue&type=template&id=6489d3b8&scoped=true"
import script from "./RightButtons.vue?vue&type=script&lang=js"
export * from "./RightButtons.vue?vue&type=script&lang=js"

import "./RightButtons.vue?vue&type=style&index=0&id=6489d3b8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6489d3b8"]])

export default __exports__